import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { Bedomare } from '../../models/bedomare.model';
import { OrganisatoriskHemvist } from '../../models/organisatorisk-hemvist.model';
import { Utbildning } from '../../models/utbildning.model';
import { Erfarenhet } from '../../models/erfarenhet.model';
import { Program } from '../../models/program.model';
import { BedomareViewModel } from '../../models/bedomare-view-model.model';
import { Nyckelord } from '../../models/nyckelord.model';
import { ClaimResult } from '../../models/claim-result';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
  }),
};

@Injectable({ providedIn: 'root' })
export class BedomareClient {
  private bedomningsPortalUrl = environment.etjansterCommonApiUrl + '/bedomare';

  constructor(private http: HttpClient) {}

  public fetchCurrentBedomare(): Observable<Bedomare> {
    const url = `${this.bedomningsPortalUrl}`;

    return this.http.get<Bedomare>(url, httpOptions);
  }

  public updateBedomare(bedomare: Bedomare): Observable<Bedomare> {
    const url = `${this.bedomningsPortalUrl}/update`;

    return this.http.post<Bedomare>(url, bedomare, httpOptions);
  }

  public addNyckelord(nyckelord: string): Observable<Nyckelord> {
    const url = `${this.bedomningsPortalUrl}/addkeyword`;
    const model = { titel: nyckelord };

    return this.http.post<Nyckelord>(url, JSON.stringify(model), httpOptions);
  }

  public getNyckelord(): Observable<Nyckelord[]> {
    const url = `${this.bedomningsPortalUrl}/keywords`;

    return this.http.get<Nyckelord[]>(url, httpOptions);
  }

  public getOrganisatoriskHemvist(): Observable<OrganisatoriskHemvist[]> {
    const url = `${this.bedomningsPortalUrl}/organizationalresidence`;

    return this.http.get<OrganisatoriskHemvist[]>(url, httpOptions);
  }

  public getUtbildning(): Observable<Utbildning[]> {
    const url = `${this.bedomningsPortalUrl}/educations`;

    return this.http.get<Utbildning[]>(url, httpOptions);
  }

  public getErfarenhet(): Observable<Erfarenhet[]> {
    const url = `${this.bedomningsPortalUrl}/experience`;

    return this.http.get<Erfarenhet[]>(url, httpOptions);
  }

  public getProgram(): Observable<Program[]> {
    const url = `${this.bedomningsPortalUrl}/programs`;

    return this.http.get<Program[]>(url, httpOptions);
  }

  public fetchBedomareData(): Observable<BedomareViewModel> {
    const url = `${this.bedomningsPortalUrl}/bedomareInfo`;

    return this.http.get<BedomareViewModel>(url, httpOptions);
  }

  public assignBedomare(secret: string): Observable<ClaimResult> {
    const url = `${this.bedomningsPortalUrl}/assign`;

    return this.http.post<ClaimResult>(
      url,
      JSON.stringify(secret),
      httpOptions,
    );
  }
}
